export const login = (payload) => ({
    type: "LOGIN_USR",
    payload
})

export const logout = (payload) => ({
    type: "LOGOUT_USR",
    payload
})

export const manage_user = (payload) => ({
    type: "MANAGE_USER",
    payload
})

export const reset_user = (payload) => ({
    type: "RESET_USER",
    payload
})